// The full version of Select2 is required to use dropdownCssClasses.
import 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.css';
import 'select2-bootstrap-theme/dist/select2-bootstrap.css';
import $ from 'jquery';

// Fix autofocus of search field not working due to a bug in jQuery.
// Also prevents the page from focusing the first search field, should there be multiple.
// Credit: https://github.com/select2/select2/issues/5993
$(document).on('select2:open', () => {
    // on ie11, we use custom results adapter that includes the search box,
    // that search box is rendered in a race condition, thus
    // focusing it on timeout SEE: https://github.com/select2/select2/issues/3300
    // here we check if the search is in the dropdown or inside the select itself
    let focusTarget = document.querySelector('.select2-container--open .dropdown-wrapper .select2-search__field')
        || document.querySelector('.select2-container--open .select2-search__field');
    // the dropdown element appears with a small animation, so we need to focus
    // after a short time out. similar select2 behaviour exists in other
    // scripts around the portal
    setTimeout(() => {
        focusTarget && focusTarget.focus();
    }, 100)
});

// yet another ie11 problem where select2 where
// won't lose its focus after closing
// remove focused class and blur while closing and opening
// we can do it while opening because they can select a
// different select2 box and if it's the same one it
// will focus it again after it gets open.
// see https://forums.select2.org/t/stop-select2-from-keeping-focus-after-close-or-disable-spacebar/842
$(document).on('select2:close select2:opening', () => {
    setTimeout(() => {
        $('.select2-container--focus').removeClass('select2-container--focus').blur();
    },25)
});

// inputs with placeholders lose focus in ie11
// so add event lister to focus the select2
// search fields explicitly
$(document).on('click','.select2-search__field', (e) => {
    const searchInput = e.currentTarget;
    // the dropdown element appears with a small animation, so we need to focus
    // after a short time out. similar select2 behaviour exists in other
    // scripts around the portal
    if (searchInput) setTimeout(() => {
        searchInput.focus();
    },1)
})